import { RouterProvider } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { FluentProvider, Toaster } from '@fluentui/react-components';
import { AuthProvider } from '@app/providers/AuthProvider';
import { ThemeProvider, useTheme } from '@app/providers/ThemeProvider';
import { I18nProvider } from '@app/providers/I18nProvider';
import { queryClient } from '@app/providers/QueryProvider';
import { router } from '@app/Router';

function AppContent() {
  const { theme } = useTheme();

  return (
    <FluentProvider theme={theme}>
      <Toaster position="top-end" />
      <AuthProvider>
        <RouterProvider router={router} />
      </AuthProvider>
    </FluentProvider>
  );
}

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <I18nProvider>
        <ThemeProvider>
          <AppContent />
        </ThemeProvider>
      </I18nProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}
